import { render, staticRenderFns } from "./MiddleRemote.vue?vue&type=template&id=5b6e9544&scoped=true"
import script from "./MiddleRemote.vue?vue&type=script&lang=js"
export * from "./MiddleRemote.vue?vue&type=script&lang=js"
import style0 from "./MiddleRemote.vue?vue&type=style&index=0&id=5b6e9544&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e9544",
  null
  
)

export default component.exports